import { useSelector } from 'react-redux';
import { userPaymentAccountsSelector } from 'modules/payments/store/user-payment-accounts/selectors';
import { exchangeRatesSelector } from 'modules/payments/store/exchange-rates/selectors';
import { convertCryptoToUsd } from 'shared/utils';

/**
 * @deprecated Use `userPaymentAccountsSelector.getActiveAccounts` instead.
 */
export const useUserAccounts = () => {
  const mainAccount = useSelector(userPaymentAccountsSelector.mainAccount);
  const mainAccountBalance = mainAccount?.amount ?? 0;
  const mainAccountRewardBalance = mainAccount?.rewardBalance;

  const platformFeeAccount = useSelector(userPaymentAccountsSelector.platformFeeAccount);
  const platformFeeAccountBalance = platformFeeAccount?.amount ?? 0;

  const mainToUsdRate = useSelector(exchangeRatesSelector.mainToUsd) ?? 0;
  const mainToPlatformFeeRate = useSelector(exchangeRatesSelector.mainToPlatformFee) ?? 0;

  const mainBalanceInUsd = convertCryptoToUsd(mainAccountBalance, mainToUsdRate);
  const platformFeeBalanceInUsd = convertCryptoToUsd(
    platformFeeAccountBalance,
    mainToPlatformFeeRate
  );

  return {
    mainAccount,
    platformFeeAccount,
    mainBalanceInUsd,
    platformFeeBalanceInUsd,
    mainAccountRewardBalance,
  };
};
